// @flow
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import {
  Box,
  Select,
  Typography,
} from '@fortress-technology-solutions/fortress-component-library/Atoms';

type Props = {
  termsDropDown: Array<Object>,
  fieldName: string,
  label: string,
  disable: boolean,
};

const RenderTermLength = ({
  termsDropDown,
  fieldName,
  label,
  disable,
}: Props) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();
  const fieldError = errors?.[fieldName];

  return (
    <Box flex={1} data-test="render-term-length">
      <Typography variant="labelLarge" component="label">
        {label}
      </Typography>
      <Controller
        name={fieldName}
        control={control}
        render={({ field }) => (
          <Select
            {...field}
            placeholder="Choose"
            options={termsDropDown}
            disabled={disable}
            error={Boolean(fieldError)}
            helperText={fieldError?.message}
            fullWidth
          />
        )}
      />
    </Box>
  );
};

export default RenderTermLength;
